import React, { useState } from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const ACHIEVEMENT_LIST = [
  'CLEAR_AGRI', 'CLEAR_TRIBE', 'CLEAR_UTOPIA', 'CLEAR_TREASURE', 'ART_SAVIOR',
  'DEFEAT_EMPIRE', 'DEFEAT_MONOTHEISM', 'DEFEAT_COMMUNITY', 'CLEAR_OPPORTUNITY_BATTLE',
  'TRUE_HUMANISM', 'DIPLOMACY_GENIUS', 'DIPLOMACY_FIGHTER', 'SECRET_EASTER_EGG'
];

const YonotsuneAchievementScreen = ({ achievements, onExport, onImport, onUnlockSecret, onReset, onClose }) => {
  const [importText, setImportText] = useState('');
  const [importStatus, setImportStatus] = useState(null);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [selectedAchId, setSelectedAchId] = useState(null);

  const handleImport = () => {
    if (importText.trim() === 'HISTORIO2026') {
      if (onUnlockSecret) {
        onUnlockSecret('SECRET_EASTER_EGG');
      }
      setImportStatus('success');
      setImportText('');
      setTimeout(() => setImportStatus(null), 3000);
      return;
    }
    const success = onImport(importText);
    if (success) {
      setImportStatus('success');
      setImportText('');
      setTimeout(() => setImportStatus(null), 3000);
    } else {
      setImportStatus('error');
      setTimeout(() => setImportStatus(null), 3000);
    }
  };

  const handleExport = () => {
    const code = onExport();
    navigator.clipboard.writeText(code).then(() => {
      alert(getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.COPIED'));
    });
  };

  const handleResetClick = () => {
    setShowResetConfirm(true);
  };

  const handleConfirmReset = () => {
    onReset();
    setShowResetConfirm(false);
  };

  const handleCardClick = (id) => {
    if (achievements.includes(id)) {
      setSelectedAchId(id);
    }
  };

  return (
    <div className="yonotsune-screen achievements-screen">
      <div className="yonotsune-header">
        <h2>{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.TITLE')}</h2>
        <div style={{ display: 'flex', gap: '10px' }}>
            <button className="yonotsune-btn danger-btn" onClick={handleResetClick}>
                {getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.RESET_BTN') || '実績リセット'}
            </button>
            <button className="yonotsune-btn close-btn" onClick={onClose}>
                {getUILoc('BUTTONS.CLOSE')}
            </button>
        </div>
      </div>

      {showResetConfirm && (
        <div className="choice-prompt-overlay" style={{ zIndex: 3000 }}>
          <div className="choice-prompt">
            <h3>{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.RESET_CONFIRM_TITLE') || '実績をリセットしますか？'}</h3>
            <p>{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.RESET_CONFIRM_DESC') || 'この操作は取り消せません。解除したすべての実績が失われます。'}</p>
            <div className="choice-options">
              <button className="yonotsune-btn danger-btn" onClick={handleConfirmReset}>{getUILoc('BUTTONS.YES')}</button>
              <button className="yonotsune-btn" onClick={() => setShowResetConfirm(false)}>{getUILoc('BUTTONS.NO')}</button>
            </div>
          </div>
        </div>
      )}

      {selectedAchId && (
        <div className="choice-prompt-overlay flavor-modal-overlay" style={{ zIndex: 3100 }} onClick={() => setSelectedAchId(null)}>
          <div className="choice-prompt flavor-modal" onClick={e => e.stopPropagation()}>
            <div className="flavor-header">
              <span className="flavor-icon">🏆</span>
              <h3>{getUILoc(`YONOTSUNE.ACHIEVEMENTS_SCREEN.LIST.${selectedAchId}.NAME`)}</h3>
            </div>
            <div className="flavor-body">
              <p className="flavor-text">
                {getUILoc(`YONOTSUNE.ACHIEVEMENTS_SCREEN.LIST.${selectedAchId}.FLAVOR`) || '...'}
              </p>
            </div>
            <div className="choice-options">
              <button className="yonotsune-btn" onClick={() => setSelectedAchId(null)}>{getUILoc('BUTTONS.CLOSE')}</button>
            </div>
          </div>
        </div>
      )}

      <div className="achievements-container">
        <div className="achievements-grid">
          {ACHIEVEMENT_LIST.filter(id => id !== 'SECRET_EASTER_EGG' || achievements.includes('SECRET_EASTER_EGG')).map(id => {
            const unlocked = achievements.includes(id);
            const name = getUILoc(`YONOTSUNE.ACHIEVEMENTS_SCREEN.LIST.${id}.NAME`);
            const desc = getUILoc(`YONOTSUNE.ACHIEVEMENTS_SCREEN.LIST.${id}.DESC`);
            return (
              <div 
                key={id} 
                className={`achievement-card ${unlocked ? 'unlocked clickable' : 'locked'}`}
                onClick={() => handleCardClick(id)}
              >
                <div className="card-glow"></div>
                <div className="ach-icon">{unlocked ? '🏆' : '🔒'}</div>
                <div className="ach-details">
                  <h3>{name}</h3>
                  <p>{desc}</p>
                  <span className="ach-status">{unlocked ? getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.UNLOCKED') : getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.LOCKED')}</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="achievements-io">
          <h3>{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.IO_TITLE')}</h3>
          <p>{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.IO_DESC')}</p>
          
          <div className="io-controls">
            <button className="yonotsune-btn green-btn" onClick={handleExport}>{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.COPY_CODE')}</button>
            <div className="import-wrapper">
              <input 
                type="text" 
                placeholder={getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.PASTE_PLACEHOLDER')}
                value={importText} 
                onChange={(e) => setImportText(e.target.value)} 
              />
              <button className="yonotsune-btn" onClick={handleImport}>{getUILoc('BUTTONS.IMPORT')}</button>
            </div>
          </div>
          {importStatus === 'success' && <p className="status-msg success">{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.SUCCESS_IMPORT')}</p>}
          {importStatus === 'error' && <p className="status-msg error">{getUILoc('YONOTSUNE.ACHIEVEMENTS_SCREEN.FAILED_IMPORT')}</p>}
        </div>
      </div>
    </div>
  );
};

export default YonotsuneAchievementScreen;
